export default __webpack_public_path__ + "static/in-browser-apps-preview-0-35d131189f00f0ddd1d0647ea7505d37.png";